// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-section-wrapper[data-v-4bc69c61] {\n  background: #fff;\n  padding: 16px 24px;\n}\n", ""]);
// Exports
module.exports = exports;
